var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookIconBlue = function SvgFacebookIconBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8a8 8 0 1 0-9.933 7.764v-5.32h-1.65V8h1.65V6.946c0-2.722 1.233-3.984 3.906-3.984.507 0 1.381.1 1.74.198v2.216c-.19-.02-.518-.03-.925-.03-1.312 0-1.819.497-1.819 1.79V8h2.614l-.45 2.445H9.47v5.496A8 8 0 0 0 16.5 8Z",
    fill: "#0866FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.634 10.445 12.083 8H9.47v-.865c0-1.292.506-1.789 1.818-1.789.407 0 .735.01.924.03V3.16c-.357-.1-1.232-.198-1.739-.198-2.673 0-3.905 1.262-3.905 3.984V8h-1.65v2.445h1.65v5.32a8.014 8.014 0 0 0 2.901.176v-5.496h2.164Z",
    fill: "#fff"
  })));
};
export default SvgFacebookIconBlue;